module.exports = __webpack_public_path__ + "media/logos/law360-logo-black-d3bf017d.png";